import React from "react";
import styles from "./NotificationItem.module.scss";

const NotificationItem = ({
  item,
  meta,
  formatRelative,
  dense = false,
  showTypeBadge = false,
  showStatus = false,
}) => {
  const { actor = {}, title, body, type, unread, createdAt } = item || {};
  const { color, Icon } = meta || {};
  const size = dense ? 34 : 40;

  const renderAvatar = () => {
    if (actor.avatar) {
      return (
        <img
          src={actor.avatar}
          alt={actor.name || "avatar"}
          style={{ "--avatar-size": `${size}px` }}
          className={styles.avatar}
        />
      );
    }
    return (
      <div
        className={styles.avatarFallback}
        style={{ "--avatar-size": `${size}px`, "--avatar-bg": color || "#6b7280" }}
      >
        {Icon ? <Icon size={16} /> : <span className={styles.avatarInitial}>{(actor.name || "N").charAt(0)}</span>}
      </div>
    );
  };

  return (
    <div className={styles.item}>
      {renderAvatar()}
      <div className={styles.body}>
        <div className={styles.headerRow}>
          <div className={styles.titleGroup}>
            <strong className={styles.title} title={title}>
              {title}
            </strong>
            <strong className={styles.text} title={body}>
              {body}
            </strong>
          </div>
          {unread && <span className={styles.unreadDot} aria-label="Unread"></span>}
        </div>

        <div className={styles.metaRow}>
          <strong className={styles.timestamp}>{formatRelative(createdAt)}</strong>
          {showTypeBadge && (
            <span
              className={styles.typeBadge}
              style={{ "--badge-bg": `${color}1a`, "--badge-fg": color || "#334155" }}
            >
              {type}
            </span>
          )}
          {showStatus && (
            <span className={`${styles.statusBadge} ${unread ? styles["statusBadge--unread"] : ""}`}>
              {unread ? "Unread" : "Read"}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
